if (!customElements.get('preorder-message')) {
  class PreorderMessage extends customElements.get('product-message') {
    constructor() {
      super();
    }

    /**
     * Override the init method to prevent showing the message initially
     */
    init() {
      // Overriding without calling the superclass's init method to prevent initial show
      if (this.dataset.persistentClose && !window.Shopify.designMode) {
        const closedMessages = window.theme.storageUtil.get('closed-messages', true) || [];
        if (closedMessages && closedMessages.includes(this.dataset.blockId)) {
          this.remove();
        }
      }
    }
  }

  customElements.define('preorder-message', PreorderMessage);
}
